
































import DemoPageConfig, { DemoPageMode } from './DemoPageConfig'
import DemoFile from '../../classes/Main/DemoFile'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ComButtonIcon from './ComButtonIcon/ComButtonIcon.vue'

export default {
  name: 'vue-book-menu',
  components: {
    ComButtonIcon,
    FontAwesomeIcon,
  },
  props: {
    currentFile: {
      type: DemoFile,
      required: false,
    },
    config: {
      type: DemoPageConfig,
      required: true,
    },
  },
  computed: {
    DemoPageMode: () => DemoPageMode,
  },
}
